"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneSet = void 0;
var PhoneSet;
(function (PhoneSet) {
    PhoneSet["cmu69"] = "cmu69";
    PhoneSet["novo_nl37"] = "novo-nl37";
    PhoneSet["novo_cmn111"] = "novo-cmn111";
    PhoneSet["novo_ar35"] = "novo-ar35";
    PhoneSet["novo_fr39"] = "novo-fr39";
    PhoneSet["novo_de45"] = "novo-de45";
    PhoneSet["novo_es27"] = "novo-es27";
})(PhoneSet = exports.PhoneSet || (exports.PhoneSet = {}));
//# sourceMappingURL=phone-set.js.map